module.exports = __webpack_public_path__ + "img/05—Applications—Parental Control.cb472f1f.jpg";